<template>
  <div class="share-container" @touchmove.stop>
    <div class="share-mark"></div>
    <span class="text">
      快分享给你的好友
      <br />
      一起得豪礼吧
    </span>
    <button class="close" @click="close">关闭</button>
  </div>
</template>
<script>
export default {
  props: {
    close: {
      type: Function,
      default: () => {},
    },
  },
}
</script>

<style lang="less" scoped>
.share-container {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 99;
  display: flex;
  justify-content: center;
  align-items: center;
  .share-mark {
    position: fixed;
    z-index: 100;
    background-image: url(../assets/share-mark.png);
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    width: 186px;
    height: 133px;
    top: 41px;
    right: 36px;
  }
  .text {
    font-size: 34px;
    color: #ffffff;
    text-align: center;
  }
  .close {
    position: fixed;
    z-index: 100;
    width: 100px;
    height: 100px;
    left: 50%;
    margin-left: -50px;
    border-radius: 50%;
    color: #fff;
    text-align: center;
    bottom: 90px;
    background-image: url(../assets/btn-share-colse.png);
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    width: 100px;
    height: 100px;
    color: transparent;
  }
}
</style>
